import { ff } from '@atlassian/jira-feature-flagging';
import {
	getJiraQueryEcosystemFirstSeenOnIssueView,
	getContentPanelsQuery,
	getEcosystemQuery,
} from '@atlassian/jira-issue-fetch-services-common';
import type { GiraQuery } from '@atlassian/jira-issue-fetch-services/src/common/utils/client';
import type { DynamicGraphQlResponse } from '@atlassian/jira-issue-view-common-types/src/gira';
import { getQuery as getCommentsQuery } from '../comments';
import { getGlancesQuery, getLegacyRightWebPanelsQuery } from '../ecosystem';
import { getQuery as getTimeTrackingQuery } from '../jira-settings';

export type DynamicIssueQueryParams = {
	shouldRefreshComments?: boolean;
};

export const buildDynamicIssueQuery = ({
	shouldRefreshComments,
}: DynamicIssueQueryParams = {}): GiraQuery<DynamicGraphQlResponse> =>
	`query issueViewDynamicQuery($issueKey: String!) {
        ${getJiraQueryEcosystemFirstSeenOnIssueView()}
        viewIssue(issueKey: $issueKey) {
            ${shouldRefreshComments === true ? getCommentsQuery() : ''}  
            ${getEcosystemQuery()}
            ${ff('issue-view-remove-glancesfield-from-query_fyj0g') ? getLegacyRightWebPanelsQuery() : getGlancesQuery()}
            ${
							// only fetch dead glancesField if it's already removed (using legacyRightWebPanels)
							ff('issue-view-remove-glancesfield-from-query_fyj0g') &&
							ff('implement-dead-glancesfield-query_f71sc')
								? getGlancesQuery()
								: ''
						}
            ${getContentPanelsQuery()}
        }
        ${getTimeTrackingQuery()}
        activitySortOrder
    }`;
